import React from 'react'
import { TextStyle } from 'react-native'
import { TextChildren, VoidFunction } from 'lib/types'
import { createStyles, useStyles } from 'lib/styles'
import { BaseText } from './BaseText'

type SubheadingProps = {
    numberOfLines?: number,
    onPress?: VoidFunction,
    style?: TextStyle,
    forceColor?: string,
    children?: TextChildren
}

export const Subheading: React.FunctionComponent<SubheadingProps> = ({
    children,
    numberOfLines,
    onPress,
    style = {},
    forceColor
}) => {
    const { styles } = useStyles(stylesheet)

    return (
        <BaseText
            onPress={onPress}
            style={{
                ...styles.text,
                ...style
            }}
            numberOfLines={numberOfLines}
            forceColor={forceColor}
            children={children}
        />
    )
}

const stylesheet = createStyles(theme => ({
    text: {
        ...theme.typography.subheading,
        color: theme.colors.lightGray,
        fontSize: 16,
        lineHeight: 20
    }
}))
